import styled from "styled-components";
import BottomBar from "../components/ui/bottom-bar";
import Verify from "../components/verify/verify";
import { HOOPER_DARK_GRAY } from "../shared/constants";

// This screen is a fixed dark full-bleed takeover (independent of the app's
// light/dark scheme), like HubMaintenanceBlocker — so `background` and
// `color` intentionally stay hardcoded rather than following
// background.default/text.primary, which would go white in the light
// scheme. `#16181a` was drift from HOOPER_DARK_GRAY (`#16191a`); resolved to
// the canonical constant, still a fixed (non-scheme) value.
const Section = styled.section`
  background: ${HOOPER_DARK_GRAY};
  margin: -24px;
  min-height: 100vh;
  color: #fff;
  display: flex;
  flex-direction: column;
`;

export default function VerifyView() {
  return (
    <Section>
      <Verify />
      <BottomBar />
    </Section>
  );
}
